export const socialsData = {
  github: "https://github.com/gauravpathak346",
  facebook: "https://www.facebook.com/profile.php?id=100005754767375",
  linkedIn: "https://www.linkedin.com/in/pathikgaurav/",
  instagram: "https://www.instagram.com/pathik_gaurav/",
  codepen: "https://codepen.io/",
  twitter: "https://x.com/gauravpathak346",
  reddit: "https://www.reddit.com/user/",
  blogger: "https://mernstackdev.com/",
  medium: "https://medium.com/@",
  stackOverflow: "https://stackoverflow.com/users/",
  gitlab: "https://gitlab.com/",
  youtube: "https://youtube.com/",
};
